import { PasswordRecoveryPage } from "./PasswordRecoveryPage";
import { strings } from "../lib/strings";

export function SetupPasswordPage(): JSX.Element {
  return (
    <PasswordRecoveryPage
      otpType="invite"
      title={strings.setup.pageTitle}
      lead={strings.setup.lead}
      successTitle={strings.setup.successTitle}
      successBody={strings.setup.successBody}
      invalidLinkTitle={strings.setup.invalidLinkTitle}
      invalidLinkBody={strings.setup.invalidLinkBody}
    />
  );
}
